import React, { useEffect } from "react";
import "./IndexPage.css";
import { useState } from 'react';
import Header from "../components/Header.js"
import Footer from "../components/Footer.js"
import Landing from "../components/landing/Landing.js";
import { Modal } from 'react-responsive-modal';
import ContactModalBody from "../components/ContactModalBody.js"
import ConfidentialityModalBody from "../components/ConfidentialityModalBody.js"
import MessageModalBody from "../components/MessageModalBody.js"
import HttpActionModalBody from "../components/HttpActionModalBody.js"
import TermsBody from "../components/TermsBody.js"
import { notify } from "../api.js";
import 'react-responsive-modal/styles.css';

const IndexPage = ({ page }) => {
    const [contactModalOpen, setContactModalOpen] = useState(false);
    const [messageModalOpen, setMessageModalOpen] = useState(false);
    const [httpActionlModalOpen, setHttpActionModalOpen] = useState(false);

    const showContactDialog = () => setContactModalOpen(true);
    const closeContactDialog = () => setContactModalOpen(false);
    const closeMessageDialog = () => setMessageModalOpen(false);
    const closeHttpActionDialog = () => setHttpActionModalOpen(false);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [page]);

    useEffect(() => {
        if (page == "message") {
            setMessageModalOpen(true);
        }
        if (page == "contact") {
            setContactModalOpen(true);
        }
        if (page == "confirm_email") {
            setHttpActionModalOpen(true);
        }
        if (page == "unsubscribe") {
            setHttpActionModalOpen(true);
            notify(window.location);
        }
    }, []);



    return (
        <>
            <Modal animationDuration={0}
                ariaLabelledby="contact-title" open={contactModalOpen} onClose={closeContactDialog} center showCloseIcon={false} classNames={{ modal: 'modalClass' }}>
                <ContactModalBody hideModal={closeContactDialog} />
            </Modal>
            <Modal animationDuration={0}
                open={messageModalOpen} onClose={closeMessageDialog} center showCloseIcon={false} classNames={{ modal: 'modalClass' }}>
                <MessageModalBody hideModal={closeMessageDialog} />
            </Modal>
            <Modal animationDuration={0}
                open={httpActionlModalOpen} onClose={closeHttpActionDialog} center showCloseIcon={false} classNames={{ modal: 'modalClass' }}>
                <HttpActionModalBody hideModal={closeHttpActionDialog} page={page} />
            </Modal>


            <Header showAskAnythingDialog={showContactDialog}></Header>
            {(page == "index" || page == "message" || page == "contact" || page == "confirm_email" || page == "unsubscribe") && (
                <>
                    <Landing showAskAnythingDialog={showContactDialog}></Landing>

                </>
            )}
            {(page == "terms") && (
                <>
                    <main className="lp-legal"><TermsBody></TermsBody></main>
                </>
            )}
            {(page == "confidentiality") && (
                <>
                    <main className="lp-legal"><ConfidentialityModalBody></ConfidentialityModalBody></main>
                </>
            )}


            <Footer showAskAnythingDialog={showContactDialog}></Footer>
        </>
    )
}

export default IndexPage;